<template>
  <div class="main-wrapper-container publication-page">
    <material-block/>
  </div>
</template>

<script>
import Toggle from "@/components/shared/toggle/Toggle.vue";
import ToggleWithTitle from "@/components/shared/toggle/ToggleWithTitle.vue";
import MaterialBlock from "@/components/entities/block/MaterialBlock.vue";

export default {
  name: "CreateNewsPage",
  components: {MaterialBlock},

}
</script>

<style scoped>

</style>
